<template>
  <div class="sales_report__table">
    <vs-card id="data-loading">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-3/5 md:w-2/3 mx-auto">
          <!-- export data btns -->
          <div class="export__btns w-full text-center">
            <vs-button color="success" class="mx-2" type="filled" @click="$emit('exportReport', 'excel')">Excel</vs-button>
            <vs-button color="success" class="mx-2" type="filled" @click="$emit('exportReport', 'pdf')">PDF</vs-button>
          </div>

          <!-- table titles -->
          <div class="table_title w-full text-center mt-5">
            <h1 class="text-4xl">Overall Sales</h1>
            <p class="font-semibold text-base mt-3">{{ formatDateTime(fromDate) }} - {{ formatDateTime(toDate) }}</p>
          </div>

          <!-- employee Name -->
          <div class="employee_name text-center mt-5">
            <h3>
              Employee Name :- <span>{{ (user && user.username) || '' }}</span>
            </h3>
          </div>

          <!-- register Name -->
          <div class="register_name text-center mt-5">
            <h3>
              Register Name :- <span>{{ (register && register.register_name) || '' }}</span>
            </h3>
          </div>

          <!-- data -->
          <div class="data__table mt-5">
            <vs-table ref="reportTable" id="table-loading" class="vs-con-loading__container" noDataText="" stripe :sst="true" :data="[]">
              <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th>CANNABIS</vs-th>
                <vs-th>NON-CANNABIS</vs-th>
                <vs-th>TOTAL</vs-th>
              </template>

              <template>
                <vs-tr>
                  <vs-td>Sales</vs-td>
                  <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.subTotal) | currencyFilter }}</vs-td>
                  <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.subTotal) | currencyFilter }}</vs-td>
                  <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.subTotal + reports_data.nonCannabisData.subTotal) | currencyFilter }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Discount</vs-td>
                  <vs-td>${{ calculateDiscountCannabis | currencyFilter }}</vs-td>
                  <vs-td>${{ calculateDiscountNonCannabis | currencyFilter }}</vs-td>
                  <vs-td>${{ (calculateDiscountCannabis + calculateDiscountNonCannabis) | currencyFilter }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Redeem Discount</vs-td>
                  <vs-td>${{ (reports_data.cannabisData && reports_data.cannabisData.redeemDiscount) | currencyFilter }}</vs-td>
                  <vs-td>${{ (reports_data.nonCannabisData && reports_data.nonCannabisData.redeemDiscount) | currencyFilter }}</vs-td>
                  <vs-td>${{ reports_data.cannabisData && (reports_data.cannabisData.redeemDiscount + reports_data.nonCannabisData.redeemDiscount) | currencyFilter }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>Returns</vs-td>
                  <vs-td>${{ calculateReturnCannabis | currencyFilter }}</vs-td>
                  <vs-td>${{ calculateReturnNonCannabis | currencyFilter }}</vs-td>
                  <vs-td>${{ (calculateReturnCannabis + calculateReturnNonCannabis) | currencyFilter }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { paymentMixins } from '@/utils/paymentTypes'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'SalesReportTable',

  props: {
    fromDate: {
      type: String,
      default: moment().startOf('day').toString()
    },

    toDate: {
      type: String,
      default: moment().endOf('day').toString()
    },

    user: Object,

    register: Object
  },

  mixins: [paymentMixins, dateMixins],

  computed: {
    ...mapState('report', ['reports_data']),

    calculateDiscountCannabis() {
      return Math.max(0, this.reports_data.cannabisData && this.reports_data.cannabisData.discountAmt - this.reports_data.cannabisReturnData.returnDiscount)
    },

    calculateDiscountNonCannabis() {
      return Math.max(0, this.reports_data.nonCannabisData && this.reports_data.nonCannabisData.discountAmt - this.reports_data.nonCannabisReturnData.returnDiscount)
    },

    calculateReturnCannabis() {
      return Math.max(0, this.reports_data.cannabisReturnData && this.reports_data.cannabisReturnData.returnSubTotal)
    },

    calculateReturnNonCannabis() {
      return Math.max(0, this.reports_data.nonCannabisReturnData && this.reports_data.nonCannabisReturnData.returnSubTotal)
    }
  },

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>

<style>
</style>